module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/The-Stuarts-A-Bloody-Reign.2e127dd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/The-Stuarts-A-Bloody-Reign.jpg
// module id = nSrz
// module chunks = 0